"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TrWithoutDocs = (0, _context.styledWithTheme)('tr')(function (_ref) {
  var selectors = _ref.theme.selectors,
      disabled = _ref.disabled,
      hasBackgroundColor = _ref.hasBackgroundColor,
      hasTopBorderWhenExpanded = _ref.hasTopBorderWhenExpanded,
      isClickable = _ref.isClickable,
      isExpandableContent = _ref.isExpandableContent;
  var clickableStyles = {};
  var outlineStyle = (0, _utils.addOutline)(_constants.ROW_HOVER_OUTLINE_WIDTH, _constants.ROW_HOVER_OUTLINE_OFFSET, selectors.color(_constants.ROW_HOVER_OUTLINE_COLOR), undefined, selectors.radius(_constants.TABLE_RADIUS));

  if (isClickable) {
    clickableStyles = disabled ? {
      cursor: 'not-allowed',
      position: 'relative'
    } : {
      cursor: 'pointer',
      position: 'relative',
      ':hover': outlineStyle.focus
    };
  }

  var expendedCellStyles = {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    marginTop: 0,
    marginBottom: 0
  };
  var expandedStyles = isExpandableContent ? {
    th: expendedCellStyles,
    td: expendedCellStyles
  } : undefined;
  var borderTopStyles = !isExpandableContent || isExpandableContent && hasTopBorderWhenExpanded ? {
    ':not(:first-of-type)': {
      td: {
        borderTop: "".concat(_constants.BORDER_WIDTH_INNER, "px solid ").concat(selectors.color(_constants.BORDER_COLOR))
      }
    }
  } : undefined;
  var backgroundColorStyles = hasBackgroundColor ? {
    backgroundColor: selectors.color(_constants.BACKGROUND_SHADE_COLOR)
  } : undefined;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, borderTopStyles), expandedStyles), clickableStyles), backgroundColorStyles);
});
var Tr = (0, _stencilReactDesc.describe)(TrWithoutDocs).description("Stencil-styled HTML 'tr' element.");
Tr.propTypes = {
  isClickable: _stencilReactDesc.PropTypes.bool.description('Whether the row is clickable.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Whether the clickable action of the row is currently disabled.'),
  isExpandableContent: _stencilReactDesc.PropTypes.bool.description('Whether the row is the expandable content of an expandable row.'),
  hasBackgroundColor: _stencilReactDesc.PropTypes.bool.description('Whether to apply a background shade, used in striped table and expandable content.')
};
Tr.displayName = 'Tr';
var _default = Tr;
exports.default = _default;